import { faMinus } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const MinusIcon = () => {
  return <FontAwesomeIcon icon={faMinus} size="xs" />
}

export default MinusIcon
